import React from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { createGTMTracking, getGTMAttributes } from '../../utils/gtm/gtm-tracking';
import { Button } from '../ui/atoms/Button';

interface FreeTrialButtonProps {
  className?: string;
  variant?: "default" | "outlined";
  origin: string;
  size?: "sm" | "md" | "lg";
}

const ArrowIcon = () => (
  <svg
    className="w-4 h-4 sm:w-5 sm:h-5 text-dark-invirtus"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13 6L19 12L13 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 12H19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FreeTrialButton: React.FC<FreeTrialButtonProps> = ({
  className = "",
  variant = "default",
  origin,
  size,
}) => {
  const { t } = useTranslation('marketing');
  const navigate = useNavigate();

  const handleFreeTrial = () => {
    navigate('/signup?plan=free_trial');
  };

  const isOutlined = variant === "outlined";

  return (
    <Button
      label={t('cta.free_trial')}
      type={isOutlined ? "outlined" : "contained"}
      intent="secondary"
      size={size ?? (isOutlined ? "md" : "lg")}
      rightIcon={isOutlined ? undefined : <ArrowIcon />}
      rightIconWithBackground={!isOutlined}
      onClick={handleFreeTrial}
      className={`whitespace-nowrap ${className}`}
      {...getGTMAttributes(createGTMTracking('SIGNUP', { origin, target: 'free_trial' }))}
    />
  );
};
